import icone from '../../assets/images/Rectangle.png';
import icone2 from '../../assets/images/Icon.png';
import infoIcon from '../../assets/images/info.png';
import heartIcon from '../../assets/images/coeur.png';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CPagination,
    CPaginationItem
} from '@coreui/react';

const CasierDashboard = () => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const popoverRefs = useRef([]);

    // Reset page when filtered data changes
    useEffect(() => {
        setCurrentPage(1);
    }, [filteredAppointments]);

    // Fetch logged user data
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Fetch appointments
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) throw new Error('Token not found');
                
                const response = await api.get('/clinic/allbilling');
                const billingsData = response.data;
                
                setAppointments(billingsData);
                
                if (UserData?.hospital_id) {
                    const userHospitalIds = UserData.hospital_id.map(hospital => hospital._id);
                    const filtered = billingsData.filter(appointment => 
                        userHospitalIds.includes(appointment?.hospitalId)
                    );
                    setFilteredAppointments(filtered);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // Fetch departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };
        fetchDepartments();
    }, []);

    // Initialize popovers
    useEffect(() => {
        popoverRefs.current.forEach((popoverEl) => {
            if (popoverEl && window.bootstrap) {
                new window.bootstrap.Popover(popoverEl, {
                    html: true,
                    trigger: 'click',
                });
            }
        });
    }, [appointments]);

    // Pagination calculations
    const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage) || 1;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredAppointments.slice(indexOfFirstItem, indexOfLastItem);

    // Page change handler
    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    // Navigation handlers
    const handleViewHistory = () => {
        navigate("/hospitaladmin/appointment_history");
    };
    
    const handleviewcalendar = (doctorId) => {
        navigate(`/hospitaladmin/doctor/calendar/${doctorId}`);
    };

    return (
        <div className='enrol'>
            <div className="py-4 doc" style={{ fontFamily: 'Arial, sans-serif' }}>
                {/* Existing welcome message and cards */}
                <p className="text-primary">{new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                <h2 className="text-primary fw-bold fs-1 mb-3" style={{color:"#0056b3"}}>Good morning, {UserData.firstname} {UserData.lastname}</h2>
                
                {/* Dashboard Cards */}
                <div className="row mb-4">
                    {/* Total Billings Card */}
                    <div className="col-md-4" style={{ borderRadius: "20px" }}>
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{
                                borderRadius: "20px", 
                                background: 'linear-gradient(180deg,rgb(73, 79, 75),rgb(77, 92, 77))'
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title text-start">Total billings</h5>
                                        <p className="card-text display-4 text-start">{filteredAppointments.length}</p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Pending Billings Card */}
                    <div className="col-md-4">
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ 
                                borderRadius: "20px", 
                                background: 'linear-gradient(180deg, #28A745, #4CAF50)' 
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title">Total of pending billings</h5>
                                        <p className="card-text display-4">
                                            {filteredAppointments.filter(apt => apt.paymentstatus === false).length || 0}
                                        </p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Paid Billings Card */}
                    <div className="col-md-4">
                        <div className="card text-white mb-3 text-center" style={{ borderRadius: "20px" }}>
                            <div className="card-body" style={{ 
                                borderRadius: "20px", 
                                background: 'linear-gradient(180deg, #FF9800, #FFC107)' 
                            }}>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <h5 className="card-title">Total of paid billings</h5>
                                        <p className="card-text display-4">
                                            {filteredAppointments.filter(apt => apt.paymentstatus === true).length || 0}
                                        </p>
                                    </div>
                                    <div className='text-end align-items-left'>
                                        <img src={icone2} alt="Icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Billings Table Section */}
                <div className="row">
                    <div className="col-12 bg-white" style={{ borderRadius: "20px" }}>
                        <div className="card p-4">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className='card-title fw-bold text-info' style={{color:"#0056b3"}}>Billings</h5>
                                </div>

                                {/* Billings Table */}
                                <div className='patientlisttable'>
                                    <CTable className="mt-5 ctable-no-border" align="middle" responsive>
                                        <CTableHead>
                                            <CTableRow className='tablehead'>
                                                <CTableHeaderCell scope="col">Payment ID</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">Service type</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">Service Code</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">Patient</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">Department</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">Amount</CTableHeaderCell>
                                                <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                                            </CTableRow>
                                        </CTableHead>
                                        <CTableBody>
                                            {currentItems.length > 0 ? (
                                                currentItems.map((billing) => (
                                                    <CTableRow className="ctable-row" key={billing._id}>
                                                        <CTableDataCell>{billing.paymentuniqueId || 'N/A'}</CTableDataCell>
                                                        <CTableDataCell>{billing.operationtype || 'N/A'}</CTableDataCell>
                                                        <CTableDataCell>{billing.operationcode || 'N/A'}</CTableDataCell>
                                                        <CTableDataCell>
                                                            {billing.patientId ? `${billing.patientId.firstname} ${billing.patientId.lastname}` : 'N/A'}
                                                        </CTableDataCell>
                                                        <CTableDataCell>
                                                            {departments.find(department => department._id === billing.department)?.name || 'N/A'}
                                                        </CTableDataCell>
                                                        <CTableDataCell>
                                                            {billing.amount || 'N/A'} {billing.currency || 'N/A'}
                                                        </CTableDataCell>
                                                        <CTableDataCell>
                                                            <span className={billing.paymentstatus ? 'coloredsucess' : 'coloredwarning'}>
                                                                {billing.paymentstatus ? 'Paid' : 'Pending'}
                                                            </span>
                                                        </CTableDataCell>
                                                    </CTableRow>
                                                ))
                                            ) : (
                                                <CTableRow>
                                                    <CTableDataCell colSpan="7" className="text-center">
                                                        No billing records found
                                                    </CTableDataCell>
                                                </CTableRow>
                                            )}
                                        </CTableBody>
                                    </CTable>
                                </div>

                                {/* Pagination Controls */}
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                    <div>
                                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredAppointments.length)} of {filteredAppointments.length} entries
                                    </div>
                                    <CPagination aria-label="Page navigation" className="mb-0">
                                        <CPaginationItem 
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </CPaginationItem>
                                        
                                        {[...Array(totalPages)].map((_, i) => (
                                            <CPaginationItem
                                                key={i + 1}
                                                active={i + 1 === currentPage}
                                                onClick={() => handlePageChange(i + 1)}
                                            >
                                                {i + 1}
                                            </CPaginationItem>
                                        ))}
                                        
                                        <CPaginationItem 
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </CPaginationItem>
                                    </CPagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CasierDashboard;